import React, { Fragment } from 'react'
import urlJoin from 'url-join'

import { DisplayBrief } from '../../utils'

import styles from './_.module.css'

interface SharedPropertiesProps {
  assignment: Assignment
  portal?: 'creator' | 'business' | 'operation'
  companyId?: string | null
}

export const SharedProperties = ({
  assignment,
  portal,
  companyId
}: SharedPropertiesProps): JSX.Element | null => {
  if (!assignment) return null
  if (!Array.isArray(assignment.shared_properties)) return null
  if (assignment.shared_properties.length === 0) return null

  const { origin } = window.location

  return (
    <Fragment>
      <div className={styles.wrapper}>
        <h3>Other submissions on this assignment</h3>
        <DisplayBrief
          data={assignment}
          fields={[
            assignment.shared_properties.map(property => {
              let fileUrl = property.submission_file.file_url

              if (
                fileUrl.startsWith('/document') &&
                portal === 'business' &&
                typeof companyId === 'string'
              ) {
                fileUrl = urlJoin(origin, companyId, fileUrl)
              }

              if (fileUrl.startsWith('/document') && portal === 'creator') {
                fileUrl = urlJoin(origin, '/d', property.id)
              }

              return {
                title: `Submission file of "${property.assignment_title}" assignment`,
                type: property.submission_file.file_url.startsWith('/document')
                  ? 'internal_links'
                  : 'links',
                value: [fileUrl]
              }
            })
          ]}
        />
      </div>
    </Fragment>
  )
}
